<template>
  <div class="layout">
    <navBar/>
    <div class="layoutBox">
      <router-view/>
    </div>
    <FooterBox />
    <div class="check" @click="checkBtn" title="切换主题">
      <img src="../assets/night.png" alt="切换暗主题" v-if="isTheme" />
      <img src="../assets/day.png" alt="切换白主题" v-else/>
    </div>
  </div>
</template>
<script>
import navBar from '@/components/navBar'
import FooterBox from '@/components/footerBox'

export default {
  name: 'layout',
  data() {
    return {
      isTheme: localStorage.getItem("theme") === "true" ? true : false,
    }
  },
  // watch:{
  //   '$route.meta':function(e){
  //     document.title = `${uniteData.name}_${this.$route.name}`;
  //   },
  // },
  mounted(){
    this.useEffect();
    if(localStorage.getItem("theme") == undefined){
      localStorage.setItem("theme", this.useEffect());
    }
    this.handleThemeChange(this.isTheme);
    document.title = `${uniteData.name}_${this.$route.name}`;
  },
  methods: {
    // 判断-跟随系统亮暗主题
    useEffect(){
      const media = window.matchMedia('(prefers-color-scheme:dark)');
      media.addEventListener('change', (e) => {
        // console.log("主题：",e.matches)
        this.isTheme = e.matches;
        localStorage.setItem("theme", e.matches);
        this.handleThemeChange(e.matches);
      })
      return media.matches;
    },
    // 设置主题颜色-修改CSS
    handleThemeChange(val){
      if (val) {
        document.documentElement.setAttribute('theme', 'dark')
      } else {
        document.documentElement.removeAttribute('theme');
      }
    },
    // 切换主题
    checkBtn(){
      this.isTheme = !this.isTheme;
      localStorage.setItem("theme", this.isTheme);
      this.handleThemeChange(this.isTheme);
    },
  },
  components: {
    navBar,
    FooterBox,
  }
}
</script>
<style scoped lang="scss">
  .layout{
    background: var(--colorF5);
  }
  .layoutBox{
    // min-width:1200px;
    margin:0 auto;
  }
  .check{
    cursor: pointer;
    bottom: 20px;
    left: 10px;
    z-index: 200;
    position: fixed;
    width: 36px;
    padding: 7px;
    background: var(--check-bg);
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.14);
  }
</style>
